import React, { useState } from "react";
import {
  OPERATIONS,
  PROCESSOR,
  PROCESSOR_3D,
  ADDITIONAL_INFO,
  UNPROCESSED_FROM_NAVVIS,
  PROCESSING_IN_NAVVIS,
  PROCESSING_IN_3D,
  PROCESSING_STATES,
  JOB_STATES_DISPLAY
} from "utils/constants";
import { roleCheck } from "utils/index";
import { useSelector } from "react-redux";
import { getCurrentRole, getCurrentUser } from "../../../../../reducers";
import Unprocessed from "./Unprocessed";
import {  } from "../../../../../../../utils/constants";
import ProcessingNavvis from "./ProcessingNavvis";
import Processing3D from "./Processing3D";

export default function Processing({
  jobService, reloadData
}) {
  const {
    attributes: {
      state
    }
  } = jobService
  const currentUser = useSelector(getCurrentUser)
  const systemRole = currentUser.attributes.role
  const currentRole = useSelector(getCurrentRole)
  const isProcessor = roleCheck(systemRole, currentRole, PROCESSOR)
  const is3DProcessor = roleCheck(systemRole, currentRole, PROCESSOR_3D)
  const allowedToDoProcessing = (isProcessor || is3DProcessor) && PROCESSING_STATES.includes(state)
  const jobStateDisplay = JOB_STATES_DISPLAY[state]?.text
  const [comment, setComment] = useState("")

  if (!allowedToDoProcessing) return <></>;

  // eslint-disable-next-line
  const Processing2DSection = () => {
    return (
      <React.Fragment>
        { state === UNPROCESSED_FROM_NAVVIS && (
          <Unprocessed
            jobService={jobService}
            comment={comment}
            setComment={setComment}
            reloadData={reloadData} />
        )}

        { state === PROCESSING_IN_NAVVIS && (
          <ProcessingNavvis
            jobService={jobService}
            comment={comment}
            setComment={setComment}
            reloadData={reloadData} />
        )}
      </React.Fragment>
    )
  }
  // eslint-disable-next-line
  const Processing3DSection = () => {
    return (
      <React.Fragment>
        { state === PROCESSING_IN_3D && (
          <Processing3D
            jobService={jobService}
            comment={comment}
            setComment={setComment}
            reloadData={reloadData} />
        )}
      </React.Fragment>
    )
  }

  return (
    <li className="activity timeline-activity" key="processing-stage">
      <div className="circle circle-outline" />
      <div className="mb-3">
        <strong>{jobStateDisplay}</strong>
      </div>
      { isProcessor && Processing2DSection()}
      { is3DProcessor && Processing3DSection()}
    </li>
  )
}